import React from 'react';
import { Link } from 'react-router-dom';
import PageTransition from '../components/PageTransition';

export default function Exhibitions() {
  return (
    <PageTransition>
      <div className="page-container">
        <Link to="/" className="back-button">&lt; back</Link>
        <h1>Exhibitions</h1>
        {/* Add your exhibitions content here */}
      </div>
    </PageTransition>
  );
}